import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import MemberList from "~/components/Blocks/MemberList";

const MemberManagement = () => {
    const history = useHistory();
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const party_id = query.get("party_id");

    const party_state = useSelector((state) => state.Party);
    
    const LinkClick = () => {
        const params = {
            party_id: party_id,
            page: query.get("page") ? query.get("page") : "1" //申込履歴のページネーション
        };
        const urlSearchParam = new URLSearchParams(params).toString();

        history.push(`/PartyDetail?${urlSearchParam}`);
    };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                参加者一覧
            </Typography>
            <Button size="small" variant="outlined" onClick={LinkClick}>
                戻る
            </Button>
            <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: "300px" }}>
                <MemberList
                    member_list={party_state.member_list}
                />
            </Grid>
        </React.Fragment>
    );
};

export default MemberManagement;
